export function isProCodeComponentType(desc) {
  return 'package' in desc;
}